<template>
  <div>
    <wc-data-box
      :loading='loading || isLoading'
      :title='$store.state.icons.dataBox.address.title'
      :titleIcon='$store.state.icons.dataBox.address.icon'
      :titleIconColor='$store.state.icons.dataBox.address.iconColor'
      :showEdit='!estimate.is_sold'
      @edit='editSiteAddress'
      :showHelp='estimate.is_sold'
      helpText='Estimates that are sold cannot have their site address changed'
    >
      <v-simple-table dense>
        <tbody>
          <tr>
            <td :class='label'>
              Address
              <v-tooltip top v-if='estimate.site_address_is_owner_address'>
                <template v-slot:activator='{ on }'>
                  <v-icon color='grey lighten-1' v-on='on'>mdi-map-marker</v-icon>
                </template>
                <span>Site address is owner's address</span>
              </v-tooltip>
            </td>
            <td :class='dataValue'>
              <span v-if='estimate.site_address_is_owner_address'>{{ estimate.owner_obj.address }}</span>
              <span v-else>{{ estimate.site_address }}</span>
            </td>
          </tr>
          <tr>
            <td :class='label'>City</td>
            <td :class='dataValue'>{{ estimate.site_city }}</td>
          </tr>
          <tr>
            <td :class='label'>Province</td>
            <td :class='dataValue'>{{ estimate.site_province }}</td>
          </tr>
          <tr>
            <td :class='label'>Postal Code</td>
            <td :class='dataValue'>{{ estimate.site_postal_code }}</td>
          </tr>
          <!-- <tr>
            <td :class='label'>Country</td>
            <td :class='dataValue'>{{ estimate.site_country }}</td>
          </tr> -->
          <tr>
            <td :class='label'>Latitude</td>
            <td :class='dataValue'>{{ estimate.lat }}</td>
          </tr>
          <tr>
            <td :class='label'>Longitude</td>
            <td :class='dataValue'>{{ estimate.lng }}</td>
          </tr>
          <tr>
            <td :class='label'>Route Position</td>
            <td :class='dataValue'>{{ (estimate.route_group ? estimate.route_group : '') + (estimate.route_number ? estimate.route_number : '' ) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showEditDialog'
      :title='$store.state.icons.dataBox.address.title'
      :icon='$store.state.icons.dataBox.address.icon'
      :iconColor='$store.state.icons.dataBox.address.iconColor'
      @cancel='cancelEdit'
      @save='saveEstimate'
      :disableButtons='!isFormValid'
      width='700'
      :fullscreen='$vuetify.breakpoint.xs'
    >
      <v-form v-model='isFormValid' ref='form'>
        <site-address-form
          v-model='estimateCopy'
        ></site-address-form>
      </v-form>
      <template v-slot:dialog-actions v-if='estimate.owner && !$vuetify.breakpoint.smAndDown'>
        <v-btn text color='success' @click='useOwnerAddress'>Use Owner's Address</v-btn>
      </template>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'
import SiteAddressForm from '@/modules/estimates/components/forms/SiteAddressForm'
export default {
  name: 'site-address',
  mixins: [formRules],
  props: {
    estimate: {
      required: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showEditDialog: false,
    label: 'grey--text',
    dataValue: 'text-right',
    estimateCopy: {}
  }),
  methods: {
    editSiteAddress () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.showEditDialog = true
       if (this.estimateCopy.id) {
        setTimeout(() => {
          console.log(this.$refs.form.validate())
        }, 100)
      } else {
        setTimeout(() => {
          this.$refs.form.resetValidation()
        }, 100)
      }
    },
    cancelEdit () {
      this.$refs.form.reset()
      this.showEditDialog = false
    },
    saveEstimate () {
      if (this.estimateCopy.route_number === '') {
        this.estimateCopy.route_number = null
      }
      this.$emit('update', this.estimateCopy)
      this.showEditDialog = false
    },
    useOwnerAddress () {
      this.estimateCopy.site_address = this.estimateCopy.owner_obj.address
      this.estimateCopy.site_city = this.estimateCopy.owner_obj.city
      this.estimateCopy.site_province = this.estimateCopy.owner_obj.province
      this.estimateCopy.site_postal_code = this.estimateCopy.owner_obj.postal
      // this.estimateCopy.site_country = this.estimateCopy.owner_obj.country
      this.$refs.form.validate()
    }
  },
  components: {
    'site-address-form': SiteAddressForm
  }
}
</script>